{
  "breadcrumbs": {
    "keyManagement": {
      "index": "$t(common:labels.keyManagement)",
      "import": "Import",
      "view": "$t(common:labels.view)",
      "detail": "$t(common:labels.details)",
      "binranges": "$t(instrumentIssuance:labels.binRanges)"
    },
    "replaceInstrument": "$t(instrumentIssuance:components.replaceInstrument.replaceInstrument)"
  },
  "buttons": {
    "resetToProduct": "Reset to Product Limits",
    "keepLastValue": "Keep Last Value",
    "addRange": "Add Range"
  },
  "labels": {
    "spendControls": "Spend Controls",
    "spendWindow": "Spend Window",
    "spendLimit": "Spend Limit",
    "usageLimit": "Usage Limit",
    "velocityWindow": "Velocity Window",
    "lifetime": "Lifetime",
    "spendWindowEnd": "End Date",
    "optionalFields": "Optional Fields",
    "validity": "Validity",
    "keyId": "Key ID",
    "keyType": "Key Type",
    "getImportParameters": "Get Import Parameters",
    "importToken": "Import Token",
    "keyTypeRequiredMessage": "Key Type is required",
    "productIdRequiredMessage": "Product ID is required",
    "checkValueColumnTitle": "Check Value",
    "keyAliasColumnTitle": "Key Alias",
    "keyArnColumnTitle": "Key ARN",
    "activationStatus": "Activation status",
    "keepExistingPin": "Keep existing pin",
    "generateNewPin": "Generate new pin",
    "confirmChanges": "$t(common:components.buttons.confirmChanges)",
    "rangeLowLimit": "BIN Range Low Limit",
    "rangeHighLimit": "BIN Range High Limit",
    "binRanges": "BIN Ranges",
    "keyReference": "Key Reference",
    "modesOfUse": "Modes of Use",
    "tr31UsageType": "TR-31 Usage Type",
    "keyAlgorithm": "Key Algorithm",
    "keyUsageType": "Key Usage Type",
    "createBinRange": "Create Bin Range",
    "quickActions": "$t(common:labels.quickActions)"
  },
  "errors": {
    "addKeyFailedMessage": "Failed to add key",
    "fetchInstrumentsFailed": "Failed to load instrument details.",
    "generationFailedMessage": "Failed to generate key.",
    "missingInstrumentIdOrRecord": "Missing instrument ID or record",
    "getImportParametersFailMessage": "Failed to retrieve the result. Please try again!",
    "invlidUUIDFormat": "Invalid UUID Format",
    "updateInstrumentStatusFailed": "Failed to update instrument status. Please try again.",
    "spendWindowEndBeforeStart": "End date must be after start date.",
    "fetchLimitsFailed": "Failed to load instrument limits. Please try again."
  },
  "components": {
    "spendControls": {
      "updateSuccess": "Spend controls updated successfully."
    },
    "spendWindow": {
      "updateSuccess": "Spend window updated successfully."
    },
    "buttons": {
      "addKey": "Add Key",
      "linkProduct": "Link Product",
      "getImportParameters": "$t(instrumentIssuance:labels.getImportParameters)",
      "viewAllKeys": "View All Keys",
      "createAlias": "Create Alias",
      "removeAlias": "Remove Alias",
      "removeLink": "Remove Link"
    },
    "keyManagementBinRanges": {
      "successMessage": "BIN range successfully created.",
      "failedMessage": "Failed to create BIN range.",
      "productNamePlaceholder": "Enter product name",
      "rangeRequiredMessage": "BIN range is required",
      "rangeMustBeNumeric": "BIN range must be a numeric value",
      "rangeMustBe16Digits": "Bin ranges must have 16 digits",
      "searchByRangeLowLimit": "Search By Low Limit"
    },
    "keyManagementData": {
      "bin": "Bin",
      "keyDetailsHeader": "Key Details",
      "associatedProductsHeader": "Associated Products"
    },
    "keyManagementDetail": {
      "associatedProductId": "Associated Product ID",
      "associatedProductName": "Associated Product Name",
      "messages": {
        "productKeyLinkSuccess": "The product was successfully unlinked."
      }
    },
    "keyManagementTable": {
      "changeAliasColumnTitle": "Change Alias",
      "keyRecordIdColumnTitle": "Key Record ID",
      "keyRecordIdActivationStatusTitle": "Activation Status",
      "keyRecordIdActivationActionTitle": "Activation Action",
      "keyTypeColumnTitle": "$t(instrumentIssuance:labels.keyType)",
      "keyDetailsColumnTitle": "$t(instrumentIssuance:components.keyManagementData.keyDetailsHeader)",
      "messages": {
        "keyActivationSuccess": "Key was successfully activated",
        "keyDeactivationSuccess": "Key was successfully deactivated"
      }
    },
    "keyManagementView": {
      "generateKey": "Generate Key",
      "importKeyPage": "Import Key Page",
      "noKeys": "No Keys Found"
    },
    "keyForm": {
      "productIdManualPlaceholder": "Add Product ID",
      "keyTypeDropdownPlaceholder": "Select a Key Type",
      "keyReferencePlaceholder": "Select a Key Reference",
      "keyAlgorithmPlaceholder": "Select a Key Algorithm",
      "keyUsageTypePlaceholder": "Select a Key UsageType",
      "keyPolicy": "Key Policy",
      "tr31Type": "Tr 31 Type",
      "tr31TypePlaceholder": "Select a Tr 31 Type",
      "modesOfUsePlaceholder": "Select a Mode Of Use",
      "expiryDate": "$t(common:components.card.expiryDate)",
      "messages": {
        "addKeySuccessMessage": "Key added successfully!",
        "successMessage": "Key generated successfully."
      }
    },
    "keyManagementService": {
      "searchByProductId": "Search by Product ID",
      "productNotFoundError": "Product with ID: {{productId}} was not found."
    },
    "importKey": {
      "keyImportType": "Key Import Type",
      "keyImportTypeDropdownPlaceholder": "Select an Import Key Type",
      "keyImportTypeRequiredMessage": "Key Import Type is required",
      "importKey": "Import Key",
      "importedKeyDetailsHeader": "Imported Key Details",
      "keyCheckValueAlgorithm": "Key Check Value Algorithm",
      "keyCheckValueAlgorithmPlaceholder": "Select a Key Check Value Algorithm"
    },
    "linkKeyToProductDrawer": {
      "title": "Link Key To Product"
    },
    "dynamicFields": {
      "publicKeyCertificate": "Public Key Certificate",
      "wrappingKeyIdentifier": "Wrapping Key Identifier",
      "randomNonce": "Random Nonce",
      "wrappedKeyBlock": "Wrapped Key Block",
      "signingKeyCertificate": "Signing Key Certificate",
      "certificateAuthorityPublicKeyIdentifier": "Certificate Authority Public Key Identifier"
    },
    "instrumentSettings": {
      "instrumentForm": "Instrument Form",
      "contactlessEnabled": "Allow Contactless Transactions",
      "contactlessLimit": "Contactless limit",
      "changeInfoMessage": "You are about to modify the default value for this instrument.",
      "proceedSave": "Once saved, this setting cannot be modified again for the next 24 hours. Are you sure you want to proceed?",
      "confirmChanges": "Confirm changes to ",
      "addContent": "Content to be added.",
      "editInstrumentUsageSettings": "Edit Instrument Usage Settings",
      "messages": {
        "successMessage": "Instrument settings updated successfully!"
      }
    },
    "createNewInstrument": {
      "addNewInstrument": "Add new instrument",
      "instrumentProducts": "$t(common:labels.instrumentProducts)",
      "step1": "Select Product",
      "step2": "Card configurations",
      "step3": "Review Customer Details",
      "step4": "Confirm Card & Address",
      "cardConfigurations": {
        "cardSettings": "Card Settings"
      },
      "charactersLeft": "characters left",
      "instrumentProduct": {
        "code": "$t(common:labels.productId)",
        "name": "$t(common:labels.productName)",
        "scheme": "$t(common:components.card.scheme)",
        "chipProfile": "Chip Profile",
        "activationStatus": "ActivationStatus",
        "type": "$t(common:labels.type)",
        "fixedFees": "Fixed Fees",
        "maximumTerm": "Maximum Term",
        "validity": "Validity:",
        "notLiveTooltip": "Instrument product is not live yet.",
        "infoMessage": "Here is the list of instrument products for the selected client. Product selection is now used in the next steps and submitted when creating the instrument. Some display-only product details are still hardcoded to align with the design until those fields are provided by the integration."
      },
      "messages": {
        "successMessage": "New Instrument added successfully!"
      }
    },
    "updateInstrument": {
      "modalTitle": "Update Instrument Status",
      "modalDescription": "Select a new status for this instrument. Note that some statuses are permanent and cannot be changed once set.",
      "statusGroupPermanent": "Permanent",
      "confirmActivateTitle": "Activate instrument",
      "confirmDeactivateTitle": "Deactivate instrument",
      "confirmActivateContent": "Are you sure you want to activate this instrument?",
      "confirmDeactivateContent": "Are you sure you want to deactivate this instrument?",
      "successActivated": "Instrument successfully activated.",
      "successDeactivated": "Instrument successfully deactivated.",
      "successUpdated": "Instrument status successfully updated."
    },
    "replaceInstrument": {
      "replaceInstrument": "Replace Instrument",
      "manageInstrumentSettings": "Manage Instrument Settings",
      "step1": "$t(instrumentIssuance:components.createNewInstrument.step2)",
      "step2": "$t(instrumentIssuance:components.createNewInstrument.step3)",
      "step3": "$t(instrumentIssuance:components.createNewInstrument.step4)",
      "warningMessage": "Are you sure you want to replace the instrument? Please note that the previous instrument will be deactivated and accountholder will not be able to use the instrument until the new instrument is issued.",
      "messages": {
        "successMessage": "Successfull instrument replacement!"
      }
    },
    "instrumentDetails": {
      "settings": "$t(common:labels.settings)",
      "deliveryAddress": "Delivery Address",
      "seqNo": "Seq No.",
      "cardVersionsHeading": "Card Versions",
      "cardVersionsSubHeading": "Previous cards assigned to the customer",
      "cardVersionPlaceholderComponent": "Card Versions - placeholder component"
    },
    "importParameters": {
      "keyMaterialTypePlaceholder": "Select the Key Material Type",
      "keyMaterialType": "Key Material Type",
      "keyMaterialTypeMessage": "Key Material Type is required",
      "wrappingkeyAlgorithm": "Wrapping Key Algorithm",
      "wrappingkeyAlgorithmPlaceholder": "Select the Wrapping Key Algorithm",
      "wrappingkeyAlgorithmMessage": "Wrapping Key Algorithm is required",
      "leave": "Leave",
      "stay": "Stay",
      "resultTitle": "Request Result",
      "copyKeyInfoSuccessMessage": "Key information copied to clipboard!",
      "resultLabels": {
        "wrappingKeyCertificate": "Wrapping Key Certificate",
        "validUntil": "Valid Until"
      },
      "messages": {
        "confirmExit": "Confirm Exit",
        "leavingMessage": "Please ensure the wrapping keys has been saved on your computer before exiting the modal."
      }
    },
    "limits": {
      "identicalDomesticLimits": "Set identical limits for POS, Online, and Contactless (Domestic)",
      "identicalInternationalLimits": "Set identical limits for ATM, POS, Online, and Contactless (International)",
      "messages": {
        "disableUsage": "Are you sure you want to disable {{title}}?",
        "warningUsage": "The cardholder will not be able to use this card for any {{firstWord}} {{transactions}}",
        "keepOrReset": "Do you want to keep the last set limit or reset it to the default value?"
      }
    }
  }
}
